<template>
  <div>
    <NavBar />
    <main role="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <form @submit.prevent="enviar">
                  <div class="form-group">
                    <div class="text-center">
                      <h5 class="mb-3">Esqueceu a senha?</h5>
                      <p>Informe seu CPF e e-mail que enviaremos as instruções para você criar uma nova senha.</p>
                    </div>
                    <label>CPF:</label>
                    <input
                      type="text"
                      :disabled="isLoading"
                      class="form-control"
                      :class="{ 'is-invalid': $v.cpf.$error, 'is-valid': !$v.cpf.$invalid }"
                      v-mask="['###.###.###-##']"
                      v-model.trim="$v.cpf.$model"
                      autocomplete="off"
                      placeholder="Informe o seu CPF"
                    />
                    <div class="invalid-feedback">
                      Informe um
                      <strong>CPF</strong> válido.
                    </div>
                  </div>
                  <div class="form-group">
                    <label>E-mail: (o mesmo utilizado no cadastro)</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="$v.email.$model"
                      :disabled="isLoading"
                      :class="{ 'is-invalid': $v.email.$error, 'is-valid': !$v.email.$invalid }"
                      autocomplete="off"
                      placeholder="E-mail"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="$v.email.$error && !$v.email.$pending && !$v.email.required"
                    >Campo obrigatório.</div>
                    <div
                      class="invalid-feedback"
                      v-if="!$v.email.$pending && !$v.email.email"
                    >
                      Informe um
                      <strong>e-mail</strong> válido.
                    </div>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block btn-flat mb-3">
                    <span v-if="!isLoading">Enviar</span>
                    <span v-if="isLoading">
                      <i class="fa fa-circle-o-notch fa-spin"></i> Enviando...
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <ColunaSocio :showLink="true" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import ColunaSocio from "@/components/ColunaSocio.vue";
import { required, email } from "vuelidate/lib/validators";
import { validaCpf } from "@/helpers";
import { baseApiUrl } from "@/global";

const axios = require("axios");

const validCPF = value => validaCpf(value);

export default {
  name: "recuperar",
  metaInfo: {
    title: 'Recuperar sua senha - Redes de Estudos Rurais'
  },
  data: function() {
    return {
      cpf: "",
      email: "",
      isLoading: false
    };
  },
  components: {
    NavBar,
    ColunaSocio
  },
  validations: {
    cpf: {
      required,
      validCPF
    },
    email: {
      required,
      email
    }
  },
  methods: {
    enviar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        axios
            .post(baseApiUrl + "api/autenticacao/recuperar", { 
              cpf: this.cpf,
              email: this.email
            })
            .then(response => {
              if (response.data.response == "success") {
                this.$toasted.global.defaultSuccess(response.data);
                this.$router.push("/");
              } else if (response.data.response == "error") {
                this.$toasted.global.defaultError(response.data);
                this.$router.push("/register");
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.$toasted.global.defaultError({
                mensagem:
                  "Não foi possível conectar ao servidor. Verifique a sua conexão ou tente novamente mais tarde."
              });
              this.isLoading = false;
            });
      }
    }
  }
};
</script>
